import { designTokens, RiCameraLine } from "@itandi/itandi-bb-ui";
import { Alertv2 } from "@itandi/itandi-bb-ui/Alertv2";
import { Box } from "@itandi/itandi-bb-ui/Box";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";
import Link from "next/link";
import type { ReactNode } from "react";
import type { DealReportImage } from "~/models/DealReportImage";
import Styles from "./ReportImageNavigation.module.scss";

type Props = {
	descriptions?: string[];
	descriptionVariant?: "info" | "subtle";
	detailPageButtonLabel: string;
	detailPagePath: string;
	optionalLabel?: boolean;
	reportImages: DealReportImage[];
	title: string;
};

export function ReportImageNavigation({
	title,
	descriptions = [],
	descriptionVariant = "subtle",
	detailPagePath,
	detailPageButtonLabel,
	reportImages,
	optionalLabel = false
}: Props) {
	const thumbnailImages = reportImages.filter(
		(i: DealReportImage) => i.thumbnailImageUrl !== null
	);
	// 4枚までサムネイルに表示
	const thumbnailCount =
		thumbnailImages.length > 3 ? 3 : thumbnailImages.length;
	const additionalImageCount = reportImages.length - thumbnailCount;
	return (
		<div className={Styles.NavigationBlock}>
			<div className={Styles.IconWrapper}>
				<RiCameraLine className={Styles.Icon} />
			</div>
			<div className={Styles.NavigationContent}>
				<Grid czz={{ flex: 1 }} gap={designTokens["spacing/xs"]}>
					<h4 className={Styles.Title}>
						{title}
						{optionalLabel ? (
							<span className={Styles.OptionalLabel}>任意</span>
						) : null}
					</h4>
					{descriptions.length > 0 ? (
						descriptionVariant === "info" ? (
							<Alertv2 maxWidth="100%" variant="info" width="100%">
								{descriptions.map((description, index) => (
									<Paragraph key={`${index}-${description}`}>
										{description}
									</Paragraph>
								))}
							</Alertv2>
						) : (
							<Box>
								{descriptions.map((description, index) => (
									<Paragraph
										color="subtle"
										key={`${index}-${description}`}
										size="xs"
									>
										{description}
									</Paragraph>
								))}
							</Box>
						)
					) : null}
					{reportImages.length > 0 && (
						<div className={Styles.SpImageCount}>
							{reportImages.length}件の画像が登録されています
						</div>
					)}
					{thumbnailImages.length > 0 && (
						<div className={Styles.ThumbnailImageList}>
							{[...Array(thumbnailCount)].map(
								(_num: number, i: number): ReactNode => (
									<img
										alt="thumbnail"
										className={Styles.ThumbnailImage}
										key={thumbnailImages[i].id}
										src={thumbnailImages[i].thumbnailImageUrl ?? ""}
									/>
								)
							)}
							{additionalImageCount > 0 && (
								<div className={Styles.AdditionalImageCountBlock}>
									+{additionalImageCount}
								</div>
							)}
						</div>
					)}
					{reportImages.length === 0 && (
						<div className={Styles.NotYet}>画像は登録されていません</div>
					)}
				</Grid>
				<div className={Styles.DetailLinkBlock}>
					<Link className={Styles.DetailLink} href={detailPagePath}>
						{detailPageButtonLabel}
					</Link>
				</div>
			</div>
		</div>
	);
}
